import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Flex, Icon, OutlineButton, Text, NakedButton } from '@qga/roo-ui/components';
import { ShowOnLargeScreen, ShowOnSmallScreen } from 'components/Layout';
import LoadingButton from 'components/LoadingButton';

// TODO: refactor to create `ButtonLink` component and update all common usage
const DesktopBackButton = styled(NakedButton)`
  color: #e40000;
`;

const MobileBackButton = styled(OutlineButton)`
  &:hover {
    color: white;
  }
`;

const ButtonGroup = ({
  desktopBackLabel,
  mobileBackLabel,
  withBackIcon,
  onClickBack,
  continueLabel,
  onClickContinue,
  continueButtonProps,
  CustomContinueButton,
  ...styleProps
}) => (
  <Flex
    justifyContent={['flex-start', desktopBackLabel ? 'space-between' : 'flex-start']}
    flexDirection={['column', 'row']}
    alignItems="center"
    {...styleProps}
  >
    {continueLabel && !CustomContinueButton ? (
      <LoadingButton variant="primary" width={['100%', 'auto']} onClick={onClickContinue} {...continueButtonProps}>
        {continueLabel}
      </LoadingButton>
    ) : null}
    {CustomContinueButton ? <CustomContinueButton /> : null}
    {desktopBackLabel ? (
      <ShowOnLargeScreen>
        <DesktopBackButton onClick={onClickBack}>
          <Flex justifyContent="space-between" alignItems="center" height="48px" fontSize="lg">
            {withBackIcon ? <Icon name="arrowBack" mr={2} /> : null}
            <Text fontSize="lg">{desktopBackLabel}</Text>
          </Flex>
        </DesktopBackButton>
      </ShowOnLargeScreen>
    ) : null}
    {mobileBackLabel ? (
      <ShowOnSmallScreen>
        <MobileBackButton variant="primary" block mt={continueLabel ? 5 : 0} onClick={onClickBack}>
          {mobileBackLabel}
        </MobileBackButton>
      </ShowOnSmallScreen>
    ) : null}
  </Flex>
);

ButtonGroup.propTypes = {
  desktopBackLabel: PropTypes.string,
  mobileBackLabel: PropTypes.string,
  withBackIcon: PropTypes.bool,
  onClickBack: PropTypes.func,
  continueLabel: PropTypes.string,
  onClickContinue: PropTypes.func,
  continueButtonProps: PropTypes.object,
  CustomContinueButton: PropTypes.any,
};

ButtonGroup.defaultProps = {
  continueButtonProps: {},
  CustomContinueButton: null,
};

export default ButtonGroup;
